// extracted by mini-css-extract-plugin
module.exports = {"workerDepartment":"List_workerDepartment_6LHVi","workerDepartmentColor":"List_workerDepartmentColor_3unpT","muted":"List_muted_24PLd","actions":"List_actions_24yfw"};